import kamala from '../../kamala'
import Popover, { directive } from './Popover'

Popover.install = function (Vue) {
  kamala(Vue)

  Vue.component(Popover.name, Popover)
  Vue.directive(directive.name, directive)
}

export default Popover
